module.exports = __webpack_public_path__ + "static/plantation-rum-logo-18ddced2062b84636b8622b44ae85ddd.jpg";